import { Button } from '@shared/components/shadcn';
import { ArrowRight } from '@shared/icons';
import { twMerge } from '@shared/themes';

type PlayButtonProps = {
  playButtonText: string;
  className?: string;
};

function PlayButton({ playButtonText, className }: PlayButtonProps) {
  return (
    <Button size="l" variant="primary" className={twMerge('z-10', className)} data-track-name="Play">
      {playButtonText}
      <ArrowRight size="small" className="ml-2" />
    </Button>
  );
}

export { PlayButton };
export type { PlayButtonProps };
